import axios from '../services/api.service';

export const projectGetAll = async (payload: object) => {
  try {
    const { data: response } = await axios.get('/projects', payload);
    console.log("PROJECTS", response)
    return response.projects;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectGetOne = async () => {
  try {
    const { data: response } = await axios.get('/projects/active');
    return response.project;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectPutOne = async (data: object) => {
  try {
    await axios.put('/projects', data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectCreate = async (data: object) => {
  try {
    const { data: response } = await axios.post('/projects', data);
    return response.project_id;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectUpdateActive = async (data: object) => {
  try {
    await axios.post('/projects/update-active-project', data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectGetMembers = async () => {
  try {
    const { data: response } = await axios.get('/projects/members');
    return response.items;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectGetStakeholders = async () => {
  try {
    const { data: response } = await axios.get('/projects/stakeholders');
    return response.data.result;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const projectKeyPlayerGetAll = async () => {
  try {
    const { data: response } = await axios.get('/projects/key-players');
    return { items: response.items, err: null };
  } catch (error) {
    return { res: null, err: error };
  }
};

export const projectSkillGetAll = async () => {
  try {
    const { data: response } = await axios.get('/projects/skills');
    return { items: response.items, err: null };
  } catch (error) {
    return { res: null, err: error };
  }
};

export const projectInviteUser = async (invitationData: object) => {
  try {
    console.log('=== API LAYER DEBUG START ===');
    console.log('API: projectInviteUser called with data:', invitationData);
    console.log('API: Making POST request to /projects/invite-user');

    const { data: response } = await axios.post('/projects/invite-user', invitationData);

    console.log('API: Request successful, response:', response);
    console.log('=== API LAYER DEBUG END ===');

    return { success: true, data: response };
  } catch (error) {
    console.error('=== API LAYER DEBUG ERROR START ===');
    console.error('API: Error inviting user:', error);
    console.error('API: Error response:', error.response);
    console.error('API: Error status:', error.response?.status);
    console.error('API: Error data:', error.response?.data);
    console.error('=== API LAYER DEBUG ERROR END ===');

    return { success: false, error: error };
  }
};

export const projectRespondToInvitation = async (invitationId: string, responseData: object) => {
  try {
    console.log('🌐 [API DEBUG] projectRespondToInvitation called');
    console.log('📧 [API DEBUG] Invitation ID:', invitationId);
    console.log('📝 [API DEBUG] Response data:', responseData);
    console.log('🔗 [API DEBUG] API URL:', `/projects/accept-invitation/${invitationId}`);

    const { data: response } = await axios.post(`/projects/accept-invitation/${invitationId}`, responseData);

    console.log('✅ [API DEBUG] API call successful');
    console.log('📋 [API DEBUG] Response data:', response);

    return { success: true, data: response };
  } catch (error) {
    console.error('❌ [API DEBUG] API call failed:', error);
    console.error('❌ [API DEBUG] Error response:', error.response);
    console.error('❌ [API DEBUG] Error status:', error.response?.status);
    console.error('❌ [API DEBUG] Error data:', error.response?.data);

    return { success: false, error: error };
  }
};

export const projectUpdateMemberPermissions = async (memberId: string, permissionsData: object) => {
  try {
    const { data: response } = await axios.put(`/projects/members/${memberId}`, permissionsData);
    return { success: true, data: response };
  } catch (error) {
    console.error('Error updating member permissions:', error);
    return { success: false, error: error };
  }
};

export const projectDeleteMember = async (memberId: string) => {
  try {
    const { data: response } = await axios.delete(`/projects/members/${memberId}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('Error deleting team member:', error);
    return { success: false, error: error };
  }
};

// Get pending invitations for the current user
export const getPendingInvitations = async () => {
  try {
    console.log('🌐 [API DEBUG] Fetching pending invitations...');
    const { data: response } = await axios.get('/projects/pending-invitations');
    console.log('📡 [API DEBUG] Pending invitations response:', response);
    return response;
  } catch (error) {
    console.error('❌ [API DEBUG] Error fetching pending invitations:', error);
    throw error;
  }
};

// People page: list of people invited to the active project who haven't accepted.
export const getProjectPendingInvitees = async () => {
  try {
    const { data: response } = await axios.get('/projects/pending-invitees');
    return { invitees: response.invitees || [], err: null };
  } catch (error) {
    return { invitees: [], err: error };
  }
};